import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import clsx from 'clsx';
import DefaultProductListItem from './DefaultProductListItem';
var useStyles = makeStyles(function () {
  return (
    /* theme */
    {
      root: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start'
      }
      /* theme.mixins.gutters({
      display: 'flex',
      flexDirection: 'column',
      alignContent: 'center',
      alignItems: 'center',
      }),*/
      ,
      image: {},
      title: {},
      addToCart: {
        marginTop: 'auto'
      },
      productPrice: {},
      availability: {
        textAlign: 'center'
      }
    }
  );
}, {
  name: 'SxComProductImgListItem'
});
var ProductImgListItem = /*#__PURE__*/React.forwardRef(function ProductImgListItem(_ref, ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      currency = _ref.currency,
      product = _ref.product,
      _ref$ProductListItemC = _ref.ProductListItemComponent,
      ProductListItemComponent = _ref$ProductListItemC === void 0 ? DefaultProductListItem : _ref$ProductListItemC,
      rest = _objectWithoutProperties(_ref, ["classes", "className", "currency", "product", "ProductListItemComponent"]);

  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), /*#__PURE__*/React.createElement(ProductListItemComponent, _extends({
    currency: currency,
    product: product
  }, rest)));
});
ProductImgListItem.propTypes = {
  classes: PropTypes.shape({
    addToCart: PropTypes.string,
    availability: PropTypes.string,
    image: PropTypes.string,
    productPrice: PropTypes.string,
    root: PropTypes.string,
    title: PropTypes.string
  }),
  className: PropTypes.string,
  currency: PropTypes.string.isRequired,
  product: PropTypes.shape({
    href: PropTypes.string,
    name: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  ProductListItemComponent: PropTypes.elementType
};
ProductImgListItem.defaultProps = {
  classes: undefined,
  className: undefined,
  ProductListItemComponent: undefined
};
export default ProductImgListItem;